import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=4689802d&scoped=true"
import script from "./TheLogo.vue?vue&type=script&lang=js"
export * from "./TheLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689802d",
  null
  
)

export default component.exports